import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";

import store from "./store";
import ReserveRoomForm from "./components/reserve-room-form";
import ReserveExperienceForm from "./components/reserve-experience-form";
import ReserveTableForm from "./components/reserve-table-form";

export const mountPrenotazioneCamera = () => {
  ReactDOM.render(
    <Provider store={store}>
      <ReserveRoomForm />
    </Provider>,
    document.getElementById("form-prenotazione-container")
  );
};

export const mountPrenotazioneEsperienza = () => {
  ReactDOM.render(
    <Provider store={store}>
      <ReserveExperienceForm />
    </Provider>,
    document.getElementById("form-prenotazione-container")
  );
};

export const mountPrenotazioneTavolo = () => {
  ReactDOM.render(
    <Provider store={store}>
      <ReserveTableForm />
    </Provider>,
    document.getElementById("form-prenotazione-container")
  );
};
